// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__hdzEt"};